import { RequestWebApi, validateRequestErrorStatus } from "./Requests";

const controller = "MetaWhatsAppEtiqueta";

const parseApiError = (error, defaultMessage) => {
  validateRequestErrorStatus(error?.response?.status);

  const data = error?.response?.data || {};
  const message = data?.message || defaultMessage;
  const errors = data?.errors || [];

  return { message, errors };
};

export const ListarMetaWhatsAppEtiquetas = (usuarioId) => {
  if (!usuarioId || usuarioId <= 0) {
    return Promise.resolve({
      success: false,
      message: "Usuário não informado.",
      errors: [],
      etiquetas: []
    });
  }

  return RequestWebApi.get(`/${controller}/Etiquetas`, { params: { usuarioId } })
    .then((response) => {
      const { success, resultData, message, errors } = response.data || {};

      return {
        success: !!success,
        etiquetas: resultData ?? [],
        message: message ?? "",
        errors: errors ?? []
      };
    })
    .catch((error) => {
      const { message, errors } = parseApiError(error, "Erro ao listar etiquetas.");

      return {
        success: false,
        message,
        errors,
        etiquetas: []
      };
    });
};

export const PesquisarMetaWhatsAppEtiquetas = (usuarioId, termo) => {
  if (!usuarioId || usuarioId <= 0) {
    return Promise.resolve({
      success: false,
      message: "Usuário não informado.",
      errors: [],
      etiquetas: []
    });
  }

  return RequestWebApi.get(`/${controller}/Etiquetas/Pesquisar`, {
    params: { usuarioId, termo: termo ?? "" }
  })
    .then((response) => {
      const { success, resultData, message, errors } = response.data || {};

      return {
        success: !!success,
        etiquetas: resultData ?? [],
        message: message ?? "",
        errors: errors ?? []
      };
    })
    .catch((error) => {
      const { message, errors } = parseApiError(error, "Erro ao pesquisar etiquetas.");

      return {
        success: false,
        message,
        errors,
        etiquetas: []
      };
    });
};

export const ListarEtiquetasDoContato = (usuarioId, whatsAppId) => {
  if (!usuarioId || usuarioId <= 0) {
    return Promise.resolve({
      success: false,
      message: "Usuário não informado.",
      errors: [],
      etiquetaIds: []
    });
  }

  if (!whatsAppId || !String(whatsAppId).trim()) {
    return Promise.resolve({
      success: false,
      message: "WhatsAppId não informado.",
      errors: [],
      etiquetaIds: []
    });
  }

  return RequestWebApi.get(`/${controller}/Contato/Etiquetas`, {
    params: { usuarioId, whatsAppId: String(whatsAppId).trim() }
  })
    .then((response) => {
      const { success, resultData, message, errors } = response.data || {};

      return {
        success: !!success,
        etiquetaIds: resultData ?? [], // lista de int
        message: message ?? "",
        errors: errors ?? []
      };
    })
    .catch((error) => {
      const { message, errors } = parseApiError(error, "Erro ao listar etiquetas do contato.");

      return {
        success: false,
        message,
        errors,
        etiquetaIds: []
      };
    });
};

export const IncluirMetaWhatsAppEtiqueta = (etiqueta) => {
  if (!etiqueta) {
    return Promise.resolve({
      success: false,
      message: "Dados da etiqueta não informados.",
      errors: [],
      etiquetaId: 0
    });
  }

  if (!etiqueta.usuarioId || etiqueta.usuarioId <= 0) {
    return Promise.resolve({
      success: false,
      message: "Usuário não informado.",
      errors: [],
      etiquetaId: 0
    });
  }

  if (!etiqueta.nomeEtiqueta || !String(etiqueta.nomeEtiqueta).trim()) {
    return Promise.resolve({
      success: false,
      message: "Nome da etiqueta não informado.",
      errors: [],
      etiquetaId: 0
    });
  }

  if (String(etiqueta.nomeEtiqueta).trim().length > 20) {
    return Promise.resolve({
      success: false,
      message: "Nome da etiqueta deve ter no máximo 20 caracteres.",
      errors: [],
      etiquetaId: 0
    });
  }

  return RequestWebApi.post(`/${controller}/Incluir`, { etiqueta })
    .then((response) => {
      const { success, resultData, message, errors } = response.data || {};

      return {
        success: !!success,
        etiquetaId: resultData ?? 0,
        message: message ?? "",
        errors: errors ?? []
      };
    })
    .catch((error) => {
      const { message, errors } = parseApiError(error, "Erro ao incluir etiqueta.");

      return {
        success: false,
        message,
        errors,
        etiquetaId: 0
      };
    });
};

export const AtualizarMetaWhatsAppEtiqueta = (etiqueta) => {
  if (!etiqueta) {
    return Promise.resolve({
      success: false,
      message: "Dados da etiqueta não informados.",
      errors: [],
      ok: false
    });
  }

  if (!etiqueta.usuarioId || etiqueta.usuarioId <= 0) {
    return Promise.resolve({
      success: false,
      message: "Usuário não informado.",
      errors: [],
      ok: false
    });
  }

  if (!etiqueta.metaEtiquetasConversasId || etiqueta.metaEtiquetasConversasId <= 0) {
    return Promise.resolve({
      success: false,
      message: "Id da etiqueta não informado.",
      errors: [],
      ok: false
    });
  }

  if (!etiqueta.nomeEtiqueta || !String(etiqueta.nomeEtiqueta).trim()) {
    return Promise.resolve({
      success: false,
      message: "Nome da etiqueta não informado.",
      errors: [],
      ok: false
    });
  }

  if (String(etiqueta.nomeEtiqueta).trim().length > 20) {
    return Promise.resolve({
      success: false,
      message: "Nome da etiqueta deve ter no máximo 20 caracteres.",
      errors: [],
      ok: false
    });
  }

  return RequestWebApi.put(`/${controller}/Atualizar`, { etiqueta })
    .then((response) => {
      const { success, resultData, message, errors } = response.data || {};

      return {
        success: !!success,
        ok: resultData ?? false,
        message: message ?? "",
        errors: errors ?? []
      };
    })
    .catch((error) => {
      const { message, errors } = parseApiError(error, "Erro ao atualizar etiqueta.");

      return {
        success: false,
        message,
        errors,
        ok: false
      };
    });
};

export const RemoverMetaWhatsAppEtiqueta = (usuarioId, metaEtiquetasConversasId) => {
  if (!usuarioId || usuarioId <= 0) {
    return Promise.resolve({
      success: false,
      message: "Usuário não informado.",
      errors: [],
      ok: false
    });
  }

  if (!metaEtiquetasConversasId || metaEtiquetasConversasId <= 0) {
    return Promise.resolve({
      success: false,
      message: "Id da etiqueta não informado.",
      errors: [],
      ok: false
    });
  }

  return RequestWebApi.delete(`/${controller}/Remover`, {
    params: { usuarioId, metaEtiquetasConversasId }
  })
    .then((response) => {
      const { success, resultData, message, errors } = response.data || {};

      return {
        success: !!success,
        ok: resultData ?? false,
        message: message ?? "",
        errors: errors ?? []
      };
    })
    .catch((error) => {
      const { message, errors } = parseApiError(error, "Erro ao remover etiqueta.");

      return {
        success: false,
        message,
        errors,
        ok: false
      };
    });
};

export const SincronizarEtiquetasDoContato = (usuarioId, whatsAppId, metaEtiquetasConversasIds) => {
  if (!usuarioId || usuarioId <= 0) {
    return Promise.resolve({
      success: false,
      message: "Usuário não informado.",
      errors: [],
      ok: false
    });
  }

  if (!whatsAppId || !String(whatsAppId).trim()) {
    return Promise.resolve({
      success: false,
      message: "WhatsAppId não informado.",
      errors: [],
      ok: false
    });
  }

  const ids = Array.isArray(metaEtiquetasConversasIds) ? metaEtiquetasConversasIds : [];
  const payload = {
    usuarioId,
    whatsAppId: String(whatsAppId).trim(),
    metaEtiquetasConversasIds: ids
  };

  return RequestWebApi.put(`/${controller}/Contato/Etiquetas/Sincronizar`, payload)
    .then((response) => {
      const { success, resultData, message, errors } = response.data || {};

      return {
        success: !!success,
        ok: resultData ?? false,
        message: message ?? "",
        errors: errors ?? []
      };
    })
    .catch((error) => {
      const { message, errors } = parseApiError(error, "Erro ao sincronizar etiquetas do contato.");

      return {
        success: false,
        message,
        errors,
        ok: false
      };
    });
};
